import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { BehaviorSubject } from "rxjs/BehaviorSubject";
import '../rxjs-operators';

@Injectable()
export class RouterDataExtractor extends BehaviorSubject<any>{

    constructor(private router: Router, private activatedRoute: ActivatedRoute) {
        // Initialise with empty object
        super({});
        // Start listenning the navigation evemts
        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .map(() => this.activatedRoute)
            .map((route) => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .subscribe((event) => {
                // Sent the data or an empty object
                this.next(event.snapshot.data || {});
            });
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/utils/router-data-extractor.ts